import { MapAsync } from "../async/MapAsync"
import { JSONEncode } from "../encoding/JSONEncode"
import type { AsyncSequence } from "../types/AsyncSequence"
import type { GUID } from "../types/GUID"
import { StringHash } from "./StringHash"

export async function GenericHash(stream: AsyncSequence<any>): Promise<GUID> {
  return StringHash(MapAsync(e => JSONEncode(e), stream))
}
